import Close from '@mui/icons-material/Close';
import Card from '@mui/material/Card';
import { styled } from '@mui/material/styles';
import Zoom from '@mui/material/Zoom';
import { ViewModelType } from '../../../Components/ConfigurableGrid/configurable-grid-view-model';
import ConfigurableGridView from '../../../Components/ConfigurableGrid/ConfigurableGridView';

const PREFIX = 'MuiCard';

const classes = {
  paper: `${PREFIX}-root`,
  closeIcon: `${PREFIX}-closeIcon`
};

const StyledCard = styled(Card)(({ theme }) => ({
  [`&.${classes.paper}`]: {
    backgroundColor: theme.palette.background.paper,
    width: '100%'
  },
  [`& .${classes.closeIcon}`]: {
    cursor: 'pointer',
    float: 'right',
    margin: theme.spacing(1)
  }
}));

interface ProcessInformationModalProps {
  onClose: () => void;
  open: boolean;
  viewModel: ViewModelType;
}

const ProcessInformationModal = ({ onClose, open, viewModel }: ProcessInformationModalProps) => {
  return (
    <Zoom unmountOnExit in={open} timeout={{ enter: 300, exit: 250 }}>
      <div
        style={{
          zIndex: 10,
          position: 'absolute',
          width: '100%',
          height: 'calc(100% - 70px)',
          padding: '8px',
          display: 'flex'
        }}
      >
        <StyledCard>
          <Close data-testid="close-icon" className={classes.closeIcon} onClick={onClose} />
          <ConfigurableGridView viewModel={viewModel} />
        </StyledCard>
      </div>
    </Zoom>
  );
};

export default ProcessInformationModal;
